import { render, staticRenderFns } from "./PrinterDailyUsage.vue?vue&type=template&id=5ce5bbef&scoped=true"
import script from "./PrinterDailyUsage.vue?vue&type=script&lang=js"
export * from "./PrinterDailyUsage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce5bbef",
  null
  
)

export default component.exports